import TopNav from "../components/Navbars/TopNav";
import RefereeInformationCard from "../components/information_cards/RefereeInformationCard";
import PersonalDetailsCard from "../components/information_cards/PersonalDetailsCard";
import AcademicDetailsSiwes from "../components/information_cards/AcademicDetailsSiwes";
import AcademicDetailsIT from "../components/information_cards/AcademicDetailsIT";
import AcademicDetailsNDE from "../components/information_cards/AcademicDetailsNDE";
import DocumentUpload from "../components/information_cards/DocumentUpload";
import FinalAssessmentMail from "../components/information_cards/mailsend";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import {
  useGetAllinformationByid,
  useGetAcceptedbycode,
} from "../adapters/Requests";
import { Home, ChevronRight, ArrowLeft } from "lucide-react";
import Footer from "../components/Navbars/footer";
import CommentsCard from "../components/information_cards/CommentsCard";
import { internshipTypes } from "../utils/constants";
import { PageLoader } from "../components/ui/InlineLoader";

function AcceptMail() {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const [, , type] = pathname.split("/");
  const { application_id } = useParams();
  let componentToRender;

  const allApplicationInformation = useGetAllinformationByid({
    application_id,
  });
  const { data, error, isLoading } = allApplicationInformation;
  const vacancy_code = data?.vacancy?.id;
  const {
    data: acceptedData,
    error: acceptedError,
    isLoading: acceptedIsLoading,
  } = useGetAcceptedbycode(vacancy_code);

  if (isLoading) return <PageLoader text="Loading acceptance details..." />;
  if (error) {
    navigate("/error");
  }

  switch (type) {
    case "it":
      componentToRender = (
        <AcademicDetailsIT details={data?.ApplicationsAcademicQualification} />
      );
      break;
    case "siwes":
      componentToRender = (
        <AcademicDetailsSiwes
          details={data?.ApplicationsAcademicQualification}
        />
      );
      break;
    case "gap":
      componentToRender = (
        <AcademicDetailsNDE details={data?.ApplicationNYSCDetails} />
      );
      break;
    default:
      componentToRender = <></>;
  }

  const remaining = data?.vacancy?.quota - (acceptedData?.count || 0);

  const applicantSelectedCourse =
    data?.ApplicationsAcademicQualification?.course;

  const selectedVacancyCourse = data?.vacancy?.vacancyCourses?.find(
    (course) => {
      if (course && applicantSelectedCourse) {
        return (
          course?.id == applicantSelectedCourse?.id ||
          course?.courseId == applicantSelectedCourse?.id
        );
      }
      return false;
    }
  );

  const isSiwes =
    data?.vacancy?.vacancy_position?.name === internshipTypes.SIWES;

  const siwesCourseQuota = Number(selectedVacancyCourse?.quota || 0);
  const siwesCoursedUsedSlots = Number(selectedVacancyCourse?.accepted || 0);

  return (
    <div className="flex flex-col w-full flex-1">
      <TopNav />
      <div className="container max-w-[1200px]">
        <div className="main gap-4">
          <div className="flex items-center justify-between w-full mb-2">
            <div className="flex items-center gap-2 text-sm text-gray-500">
              <Link
                to="/dashboard"
                className="flex items-center hover:text-green-600 transition-colors"
              >
                <Home size={16} />
              </Link>
              <ChevronRight size={16} className="text-gray-300" />
              <Link
                to="/accapplications"
                className="hover:text-green-600 transition-colors"
              >
                Accept
              </Link>
              <ChevronRight size={16} className="text-gray-300" />
              <span className="font-semibold text-gray-900">
                Acceptance Mail
              </span>
            </div>

            <button
              onClick={() => navigate(-1)}
              className="flex items-center gap-1 text-sm font-medium text-gray-500 hover:text-gray-900 transition-colors"
            >
              <ArrowLeft size={16} /> Back
            </button>
          </div>

          <div className="space-y-5">
            <div className="flex justify-between text-sm mt-2 p-2 bg-gray-100 border border-green-500">
              <div>
                <span>
                  Internship Type :{" "}
                  <strong>
                    {data?.vacancy?.vacancy_position?.name?.toUpperCase()}
                  </strong>
                </span>
                <br />
                <span>
                  Location:{" "}
                  <strong>
                    {data?.vacancy?.business_unit?.name},{" "}
                    {data?.vacancy?.location?.name}
                  </strong>
                </span>
                <br />
                <span>
                  Total Quota : <strong>{data?.vacancy?.quota}</strong>
                </span>
                <br />
                {acceptedIsLoading ? (
                  <span>Loading accepted count...</span>
                ) : acceptedError ? (
                  <span>
                    Error loading accepted count: {acceptedError.message}
                  </span>
                ) : (
                  <span>
                    Accepted Applications :{" "}
                    <strong>{acceptedData?.count || 0}</strong>
                  </span>
                )}{" "}
                <br />
                <span>
                  Remaining Quota : <strong>{remaining}</strong>
                </span>
              </div>
              {isSiwes && (
                <div className="mr-12">
                  <span>
                    Selected Course :{" "}
                    <strong>{applicantSelectedCourse?.name}</strong>
                  </span>
                  <br />
                  <span>
                    Course Quota : <strong>{siwesCourseQuota}</strong>
                  </span>
                  <br />
                  <span>
                    Remaining :{" "}
                    <strong>{siwesCourseQuota - siwesCoursedUsedSlots}</strong>
                  </span>
                </div>
              )}
            </div>
            {remaining <= 0 ? (
              <div className="m-auto bg-white shadow-lg rounded-xl h-32 w-[90%] mt-6 flex justify-center align-middle text-center">
                <div className="mt-12 font-bold text-gray-300 text-2xl">
                  Quota met for this vacancy
                </div>
              </div>
            ) : (
              <>
                <FinalAssessmentMail
                  isSiwes={isSiwes}
                  siwesCourseQuota={siwesCourseQuota}
                  siwesCoursedUsedSlots={siwesCoursedUsedSlots}
                />
                {data?.Comments?.length > 0 && (
                  <CommentsCard comments={data?.Comments} />
                )}
                <div className="flex flex-col lg:flex-row lg:space-x-5">
                  <div className="lg:w-[calc(60%)]">
                    <div className="mb-5">
                      <PersonalDetailsCard
                        applicant={data?.Applicant}
                        nextOfKins={data?.ApplicationNextOfKins}
                      />
                      <DocumentUpload
                        documents={data?.ApplicationDocuments}
                        vacancy={vacancy_code}
                      />
                    </div>
                  </div>
                  <div className="space-y-5 lg:w-[calc(60%)]">
                    {componentToRender}
                    {!(type === "siwes") ? (
                      <RefereeInformationCard
                        referees={data?.ApplicationReferees}
                      />
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default AcceptMail;
